import React from 'react';

/**
 * Error boundary that catches render errors in the word popover.
 * Prevents a black screen and surfaces the exact error so we can fix it.
 */
export class WordPopoverErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[WordPopover crash]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            position: 'fixed',
            top: this.props.top || 100,
            left: this.props.left || 20,
            width: 340,
            background: '#1a1a2e',
            border: '1px solid #e53e3e',
            borderRadius: 12,
            padding: 16,
            zIndex: 9999,
            color: '#fff',
            fontFamily: 'monospace',
            fontSize: 12,
          }}
        >
          <div style={{ color: '#fc8181', fontWeight: 'bold', marginBottom: 8 }}>
            Oracle crashed — error details:
          </div>
          <div style={{ wordBreak: 'break-all', color: '#fbd38d' }}>
            {this.state.error?.message || String(this.state.error)}
          </div>
          <div style={{ marginTop: 8, color: '#a0aec0', fontSize: 10 }}>
            {this.state.error?.stack?.split('\n').slice(0, 3).join('\n')}
          </div>
          <button
            onClick={() => { this.setState({ hasError: false, error: null }); if (this.props.onClose) this.props.onClose(); }}
            style={{ marginTop: 12, padding: '4px 12px', background: '#2d3748', border: '1px solid #4a5568', borderRadius: 6, color: '#e2e8f0', cursor: 'pointer' }}
          >
            Close
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
